// extracted by mini-css-extract-plugin
export default {"backIcon":"models-modal_backIcon__QaPhy","headerRow":"models-modal_headerRow__4pTLO","manufacturerName":"models-modal_manufacturerName__Ptlsv"};